<div class="content-without-stepper-and-title document-scan-success">
  <div class="row">
    <div class="col-4 col-sm-8 col-md-12 col-lg-12 col-xl-12">
      <div class="img-success">
        <img id="docSuccessImg" src="assets/images/success-process.svg" alt="img_success">
      </div>

      <div class="text" id="docSuccessText" [innerHTML]="copyService.copies.document_scan_success_text">
      </div>
    </div>
  </div>
  <app-controls id="docSuccessBtns" [nextLabel]="copyService.copies.document_scan_success_btn" (next)="next()">
  </app-controls>
</div>
